export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.7-1306.28",
  commitId: "3d70725619f896625136e1c482217d3268674416",
  commitTime: "2026-09-07T13:06:28.000Z",
});
